import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Laskate Market · Your Local Marketplace</p>
        <h1>Discover Local Treasures</h1>
        <p className="lede">
          Welcome to Laskate Market, your go-to destination for unique, locally sourced products. Explore a vibrant selection of goods from artisans and vendors in your community.
        </p>
        <div className="cta-row">
          <a href="/shop" target="_blank">
            Start Shopping
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Shop Local</h2>
          <p>
            Support your community by purchasing handmade and locally sourced products. Every purchase helps local artisans thrive.
          </p>
        </article>
        <article>
          <h2>Unique Finds</h2>
          <p>
            From crafts to gourmet foods, discover one-of-a-kind items that you won’t find anywhere else. Each product tells a story.
          </p>
        </article>
        <article>
          <h2>Join Our Community</h2>
          <p>
            Become part of the Laskate Market family. Sign up for our newsletter to stay updated on new arrivals, events, and special promotions.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;